// extracted by mini-css-extract-plugin
module.exports = {"header":"group-new_header__C_N_O flex_header__QIaoO","wrapper":"group-new_wrapper__99CsT flex_wrapper__qR0T3","headTitle":"group-new_headTitle__uOLmi flex_headTitle__e_A__"};